export default "__VITE_ASSET__DwKqFdGr__"